<template>
    <div>
        <div class="main-content">
			<div class="container-fluid">
				<div class="row justify-content-center">
					<div class="col-12 col-lg-10 col-xl-8">

						<!-- Header -->
						<div class="header mt-md-5">
							<div class="header-body">
								<div class="row align-items-center">
									<div class="col">
										<!-- Title -->
										<h1 class="header-title">
											About M&O Law Consult
										</h1>
									</div>
								</div> <!-- / .row -->
							</div>
						</div>

                        <!-- Content -->
                        <div class="card">
                            <div class="card-body">
                                <h4>Story / History</h4>
                                <form>
                                    <div class="form-group">
                                        <span v-if="contentError" class="text-danger d-block">The content field is required</span>

                                        <quill-editor v-model="historyContent"
                                            ref="myQuillEditor"
                                            :options="editorOption"
                                        >
                                        </quill-editor>
                                    </div>

                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-4 offset-md-4">
                                                <button class="btn btn-success btn-block"
                                                    v-on:click.prevent="updateAbout($event)"
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    
                                </form>


                            </div>
                        </div>

					</div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>
    import appSettings from '@/assets/js/editorsettings.js'
	// require styles
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'

    import { quillEditor } from 'vue-quill-editor'
    import axios from 'axios'

    export default {
        components: {
			quillEditor
		},
        name: 'Story',
        data() {
            return {
                historyContent: '',
                editorOption: appSettings.editorOption,
                contentError: false
            }
        },
        methods: {
            // fetch  data
            fetchData() {
                axios.get(APIURL + 'admin/about/story')
                .then((response) => {
                    let res = response.data;

                    this.historyContent = res.data.content;
                })
                .catch((err) => {
                    console.log(err);
                })
            },

            //
            updateAbout(e) {
                let btn = e.currentTarget;
                let content = this.historyContent;
                if (!content) {
                    this.contentError = true;
                    return false;
                }
                this.contentError = false;
                let params = new URLSearchParams();
                params.append('content', content);

                $(btn).addClass('is-loading is-loading-sm').attr('disabled', '');

                axios.post(APIURL + 'admin/about/updatestory', params)
                .then((response) => {
                    $(btn).removeClass('is-loading is-loading-sm').removeAttr('disabled');
                    let res = response.data;

                    if (res.status == 200) {
                        this.aboutContent = res.data.content;
                        this.$swal('Success', res.msg, 'success');
                    }
                    else {
                        if (res.status == 403) {
                            $.each(res.errors, (k, v) => {
                                $('#' + k).after(v);
                            })
                        }
                        else {
                            this.$swal('Error', res.msg, 'error');
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
            }
        },
        created() {
            this.fetchData();
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/backend/about/Story.vue